import { FirebaseManager } from "@core/plugins/firebase/firebase.manager";
import { Logger } from "@core/helpers/logger.helpers";
import { isWeb, isNative } from "@core/plugins/mobile";

/**
 * TrackingManager for centralizing tracking operations across web and mobile platforms
 * using DataLayer (web) and Firebase Analytics (mobile)
 */
export class TrackingManager {
  static initialize() {
    Logger.info("TrackingManager - Initializing");
    isNative && FirebaseManager.initialize();
  }

  /**
   * Formats event data for Firebase
   * @private
   * @param {Object} data - Raw event data
   * @returns {Object|null} Formatted Firebase event or null if invalid
   */
  static formatFirebaseEvent(data) {
    const { event, params, step, path } = data;

    if (!event) return null;

    const baseEvent = { name: event };

    if (params) return { ...baseEvent, params: { params } };
    if (step) return { ...baseEvent, params: { step } };
    if (path) return { ...baseEvent, params: { path } };

    return baseEvent;
  }

  /**
   * Adds tracking event to appropriate platform
   * @param {Object} data - Event data
   */
  static async addEvent(data) {
    try {
      Logger.info("TrackingManager - Adding event", data);

      if (isWeb) {
        window.dataLayer.push(data);
        return;
      }

      const firebaseEvent = this.formatFirebaseEvent(data);
      if (firebaseEvent) {
        await FirebaseManager.logEvent(firebaseEvent);
      }
    } catch (error) {
      Logger.error("TrackingManager - Error adding event", error);
    }
  }
}
